import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { SharedUiGenderSelectModule } from '../lib/shared-ui-gender-select.module'
import { GenderSelectDocsComponent } from './gender-select-docs/gender-select-docs.component'
import { GenderSelectExampleComponent } from './gender-select-docs/gender-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiGenderSelectModule
  ],
  declarations: [
    GenderSelectDocsComponent,
    GenderSelectExampleComponent
  ],
  exports: [
    GenderSelectDocsComponent
  ]
})
export class SharedUiGenderSelectDocsModule {}
